import { Component } from 'san';

import {
    IReceiveTaskCallback,
    ITask
} from 'src/models';

import taskService from 'src/services/task.service';


export default class ReceiveTasks extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;    // 显示
        callback?: any;
        tasks: ITask[];
    } {
        return {
            isShow: false,
            callback: null,
            tasks: []
        };
    }

    inited() {
    }

    // 显示（外部调用）
    show(callback: IReceiveTaskCallback) {
        this.data.set('callback', callback);
        this.getTodoTasks();
    }

    // 隐藏（外部调用）
    hide() {
        this.data.set('isShow', false);
    }

    getTodoTasks() {
        const dataKey = 'tasks';
        const oldTasks = this.data.get(dataKey);
        taskService.getTodoTasks().then(tasks => {
            this.data.splice(dataKey, [0, oldTasks.length, ...tasks]);
            if (tasks.length) {
                this.data.set('isShow', true);
            }
        });
    }

    receive() {
        const callback: IReceiveTaskCallback = this.data.get('callback');
        taskService.receiveTasks().then(() => {
            if (callback) {
                callback();
            }
            this.data.set('isShow', false);
        });
    }
}